
import { Component, Vue } from "vue-property-decorator";
import { Settings } from "../../../core/services/configService";
import { CrudService } from "../../../core/services/crudService";
import ScrollableBanner from "../scrollableBanner.vue";
import ActivityCard from "./activityCard.vue";
import { ActivityStatus } from "@shared/crm/constants";

@Component({
  components: {
    ScrollableBanner,
    ActivityCard,
  },
})
export default class ActivitiesBanner extends Vue {
  activitiesWithParticipants: any[] = [];

  async mounted() {
    let url = `${Settings.HostName}/api/publicactivities/list`;
    let data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash");
      return;
    }
    this.activitiesWithParticipants = data.model.activities.filter(x => x.status === ActivityStatus.Ongoing).slice(0, 4);
  }
}
